const DEFAULT_ERROR_CODE = 404

const ERROR_CONFIGS = {
  410: {
    title: 'Страница недоступна',
    description: 'Ссылка устарела.',
    image: 'error-410',
    pageTitle: 'Page gone (410)',
  },
  404: {
    title: 'Такой страницы нет',
    description: 'Ссылка неверна или устарела.',
    image: 'error-404',
    pageTitle: 'Page not found (404)',
  }
}

export default {
  computed: {
    errorData() {
      const statusCode = this.error?.statusCode || DEFAULT_ERROR_CODE
      return ERROR_CONFIGS[statusCode] || ERROR_CONFIGS[DEFAULT_ERROR_CODE]
    }
  }
}
